import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { Divider } from '@abyss/web/ui/Divider';
import { Flex } from '@abyss/web/ui/Flex';
import { Markdown } from '@abyss/web/ui/Markdown';
import { Text } from '@abyss/web/ui/Text';

export const BoxContainer = styled(Box, {
  '&.abyss-box-root': {
    width: '100%',
    padding: '8px',
    textAlign: 'center',
    fontWeight: '$bold',
    marginTop: '18px',
    marginBottom: '16px',
    borderRadius: '8px',
  },
});

export const DisclaimerContainer = styled(Flex, {
  marginTop: '50px',
  '&.abyss-flex-root': {
    color: '#333',
    fontFamily: '$primary',
    fontSize: '9px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
  },
});
export const Section = styled('div', {
  padding: '10px 10px 0 10px',
  width: '100%',
});

export const SmartChoiceBox = styled('div', {
  border: '1px solid #E5E5E6',
  borderRadius: '4px',
  padding: '8px',
  marginBottom: '12px',
});

export const SmartChoiceScoreConatiner = styled('div', {
  backgroundColor: '#F3F3F3',
  borderRadius: '4px',
  padding: '2px 8px',
});

export const PrintViewDivider = styled(Divider, {
  '&.abyss-divider-root': {
    borderTop: '1px solid #CCCCCC',
    height: 0,
    marginTop: '$sm !important',
    marginBottom: '$md !important',
    transform: 'matrix(1, 0, 0, 1, 0, 0)',
  },
});

export const PrintViewProviderMediumText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '14px',
    fontWeight: '600',
    fontStyle: 'normal',
    lineHeight: '17px',
    marginBottom: '5px',
  },
});

export const PrintViewProviderBoldText = styled(Text, {
  dynamic: ({ cssProps: { isUniversityEmpty } }) => ({
    '&.abyss-text-root': {
      fontSize: '10px',
      fontWeight: isUniversityEmpty ? '400' : '700',
      lineHeight: '11.87px',
      fontStyle: isUniversityEmpty ? 'italic' : 'normal',
    },
  }),
});

export const PrintViewProviderNormalText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '10px',
    fontWeight: '500',
    fontStyle: 'normal',
    lineHeight: '11.87px',
  },
});

export const PrintViewProviderDetailsXSText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '11px',
    fontWeight: '400',
    lineHeight: '14px',
    textOverflow: 'ellipsis',
  },
});

export const StyledMarkdown = styled(Markdown, {
  fontSize: '9px',
  fontWeight: '500',
  fontStyle: 'normal',
  lineHeight: '14px',
  color: '$gray8',
  marginTop: '$md',
});

export const PremiumCareStyledCss = {
  fontSize: '10px',
  lineHeight: '11.87px',
  fontStyle: 'normal',
};

export const PremiumCareContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const PremiumCareRow = styled('div', {
  display: 'flex',
  flexDirection: 'row',
});

export const PremiumCareIconsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  paddingRight: '6px',
});

export const PremiumCareText = styled('p', {
  ...PremiumCareStyledCss,
  color: '#333333',
  fontWeight: '500',
  lineHeight: '1.2',
});

export const PremiumCareSubText = styled(StyledMarkdown, {
  ...PremiumCareStyledCss,
});

export const IconWithText = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});
